import React, { useEffect, useRef, useState } from "react";
import { Box, Grommet } from "grommet";
import { Gradient } from "./components/Gradient.js";
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import CreateEntry from "./components/CreateEntry";
import CalendarPortal from "./components/CalendarPortal";
import CanvasToggle from "./components/CanvasToggle.js";
import UserPortal from "./components/user_portal/UserPortal";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsExports.USER_POOL_ID,
      userPoolClientId: awsExports.USER_POOL_APP_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: "https://gratitude.auth.eu-west-2.amazoncognito.com",
          scopes: ["email", "openid", "phone", "profile"],
          responseType: "token",
        },
      },
    },
  },
});

function App() {
  const [canvas, setCanvas] = useState(true);
  const [calendarOpen, setCalendarOpen] = useState(false);
  const [userPortalOpen, setUserPortalOpen] = useState(false);
  const calendarRef = useRef(null);
  const userPortalRef = useRef(null);
  const gradientRef = useRef(null);
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString());

  //Initalise the Gradient Background
  useEffect(() => {
    gradientRef.current = new Gradient();
    gradientRef.current.initGradient("#gradient-canvas");
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Ensure gradientRef is set
      if (gradientRef.current) {
        gradientRef.current.triggerPulse();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarOpen && !calendarRef.current.contains(event.target)) {
        setCalendarOpen(false);
      }
      if (userPortalOpen && !userPortalRef.current.contains(event.target)) {
        setUserPortalOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [calendarOpen, userPortalOpen]);

  //use Grommet Themeing
  const journalTheme = {
    global: {
      colors: {
        brand: "black",
        focus: "black",
      },
    },
  };

  return (
    <Grommet theme={journalTheme}>
      {/* <div className="testBackground"></div> */}
      <canvas
        id="gradient-canvas"
        data-transition-in
        style={{ opacity: canvas ? 1 : 0 }}
      />
      <Box overflow="hidden" fill>
        <Authenticator.Provider>
          <Box className="container">
            <Box
              direction="row"
              align="start"
              justify="between"
              pad="none"
              className="headerBar"
            >
              <Box pad="small">
                <CalendarPortal
                  calendarOpen={calendarOpen}
                  setCalendarOpen={setCalendarOpen}
                  calendarRef={calendarRef}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </Box>
              <Box pad="small">
                <UserPortal
                  userPortalOpen={userPortalOpen}
                  setUserPortalOpen={setUserPortalOpen}
                  userPortalRef={userPortalRef}
                />
              </Box>
            </Box>
            <Box direction="row" justify="center" fill="true">
              <CreateEntry
                selectedDate={selectedDate}
                openUserPortal={() => setUserPortalOpen(true)}
              />
            </Box>
          </Box>
          <Box
            className="canvasToggle"
            direction="row"
            align="end"
            justify="start"
            pad="medium"
          >
            <CanvasToggle canvas={canvas} setCanvas={setCanvas} />
          </Box>
        </Authenticator.Provider>
      </Box>
    </Grommet>
  );
}

export default App;
